<template>
  <span>
    <slot :click="openModal">
      <v-btn @click="openModal">Change Guarantee Order</v-btn>
    </slot>
    <v-dialog
      v-model="showDialog"
      v-if="showDialog"
      max-width="700px"
      persistent
    >
      <v-card class="edit-route-wrap" :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
        <v-card-title class="px-3 pt-2">
          <h2 class="title">Change Guarantee Order</h2>
        </v-card-title>

        <div class="pa-4">
          <v-layout class="wrap">
            <v-flex class="xs12 mb-2">
              <v-layout class="wrap">
                <v-checkbox
                  v-model="useButtons"
                  small
                  hide-details
                  class="mt-1 mb-0 mx-1"
                >
                  <template v-slot:label>
                    <span class="text-body-2">Use Buttons</span>
                  </template>
                </v-checkbox>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  :outlined="$vuetify.breakpoint.xs"
                  class="mb-3 mx-1"
                  :class="{ 'mt-2': $vuetify.breakpoint.xs}"
                  @click="reverseOrder">Reverse Order<v-icon right>import_export</v-icon></v-btn>
              </v-layout>
              <div class="px-1">
                <div>
                  <draggable v-if="!useButtons" class="list-group" tag="ul" v-model="preparedData" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                    <transition-group type="transition" :name="'flip-list'">
                      <div 
                        v-for="item in preparedData" :key="item.id"
                        class="pa-2 mb-2 list-group-item"
                        style="border: 1px solid #ccc; border-radius: 4px;"
                      >
                        <v-layout>
                          <v-icon>drag_indicator</v-icon>
                          <v-layout class="flex-nowrap flex-grow-1 flex-shrink-1 pl-2">
                            <span 
                              v-if="!no_data.includes(item.name)"
                              class="d-flex"
                              style="align-items: center; overflow: hidden;"
                            >
                              <span class="d-inline-block text-truncate">{{ item.name }}</span>
                            </span>
                            <em
                              v-else
                              class="grey--text d-flex"
                              style="align-items: center;"
                            >No data</em>
                          </v-layout>
                        </v-layout>
                      </div>
                    </transition-group>
                  </draggable>
                  <ul v-else class="list-group">
                    <transition-group type="transition" :name="'flip-list'">
                    <div 
                      v-for="(item, index) in preparedData" :key="item.id"
                      class="pa-2 mb-2 noselect list-group-item use-buttons flip-list-move"
                      style="border: 1px solid #ccc; border-radius: 4px; overflow: hidden;"
                    >
                      <v-layout class="flex-nowrap">
                        <v-layout class="flex-nowrap flex-grow-1 flex-shrink-1">
                          <span 
                            v-if="!no_data.includes(item.name)"
                            class="d-flex"
                            style="align-items: center; overflow: hidden;"
                          >
                            <span class="d-inline-block text-truncate">{{ item.name }}</span>
                          </span>
                          <em
                            v-else
                            class="grey--text d-flex"
                            style="align-items: center;"
                          >No data</em>
                        </v-layout>
                        <v-flex class="flex-grow-0 flex-shrink-1">
                          <div v-if="$vuetify.breakpoint.smAndUp" class="pl-2">
                            <v-btn :disabled="!canMove(index, -1)" color="primary" class="d-block mb-1" x-small @click="move(index, -1)"><v-icon size="20px">arrow_drop_up</v-icon></v-btn>
                            <v-btn :disabled="!canMove(index, 1)" color="primary" class="d-block" x-small @click="move(index, 1)"><v-icon size="20px">arrow_drop_down</v-icon></v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-container v-if="!$vuetify.breakpoint.smAndUp" class="grid-list-md pa-0 mt-2">
                        <v-layout class="wrap">
                          <v-flex class="xs6">
                            <v-btn :disabled="!canMove(index, -1)" color="primary" block x-small @click="move(index, -1)"><v-icon size="20px">arrow_drop_up</v-icon> <span class="btn-label">Move Up</span></v-btn>
                          </v-flex>
                          <v-flex class="xs6">
                            <v-btn :disabled="!canMove(index, 1)" color="primary" block x-small @click="move(index, 1)"><v-icon size="20px">arrow_drop_down</v-icon> <span class="btn-label">Move Down</span></v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                    </transition-group>
                  </ul>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-alert
            class="pa-2 mt-4 mx-1"
            :value="!serverValidation"
            outlined
            color="error"
            icon="priority_high"
            transition="scale-transition"
          >
            <span class="caption">{{ serverValidationMessage }}</span>
          </v-alert>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeModal"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="saveLoading"
            :disabled="saveLoading"
            @click="saveChanges"
            >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import ApiService from "@/common/api.service"
import EventBus from "@/main"
import draggable from "vuedraggable";

export default {
  name: "OrderGuarantees",
  props: ['items'],
  components: {
    draggable
  },
  data: () => ({
    editable: true,
    isDragging: false,
    delayedDragging: false,

    no_data: [null, "", undefined, "null"],
    showDialog: false,
    saveLoading: false,
    preparedData: {},
    edited: false,
    useButtons: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      this.edited = true
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },

    openModal() {
      this.preparedData = _.cloneDeep(this.items)
      this.resetServerValidation()
      this.useButtons = false
      this.saveLoading = false
      this.edited = false
      this.showDialog = true
    },
    reverseOrder() {
      this.preparedData.reverse()
      this.edited = true
    },
    move (index, direction) {
      let old_index = index
      let new_index = index + direction
      this.preparedData = this.arrayMove(this.preparedData, old_index, new_index)
      this.edited = true
    },
    arrayMove(arr, old_index, new_index) {
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
      return arr
    },
    saveChanges() {
      this.resetServerValidation();
      this.saveLoading = true
      let body = { 
        guarantee_ids: this.preparedData.map(i => i.id)
      }
      ApiService.post('/gotpooperscoopers/guarantee/order', body)
        .then(response => {
          this.saveLoading = false;
          EventBus.$emit("notification", {
            status: "success",
            text: "Guarantee Order has been successfully changed."
          });
          this.closeModal();
          this.$emit('done')
        })
        .catch(({ response }) => {
          this.saveLoading = false;
          this.serverValidation = false;
          if (response.error) {
            this.serverValidationMessage = this.titleCase(response.error);
          }
        });
    },
    closeModal() {
      this.showDialog = false;
    },
    canMove (index, direction) {
      const new_index = index + direction
      const arr = _.cloneDeep(this.preparedData)
      if(new_index < 0 || new_index > arr.length - 1) {
        return false
      }
      return true
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    }
  }
}
</script>

<style>
  .flip-list-move {
  transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .list-group-item.ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    min-height: 20px;
    padding-left: 0!important;
  }
  .list-group-item {
    background: #fff;
    cursor: n-resize;
  }
  .list-group-item i {
    cursor: pointer;
  }
  .list-group-item.use-buttons {
    background: #fff;
    cursor: auto;
  }
  .noselect {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }

  @media only screen and (max-width: 400px) {
    .edit-route-wrap .btn-label {
      display: none;
    }
  }
</style>